import { render, staticRenderFns } from "./MerchantGiftCard.vue?vue&type=template&id=9f9b1148&scoped=true&"
import script from "./MerchantGiftCard.vue?vue&type=script&lang=js&"
export * from "./MerchantGiftCard.vue?vue&type=script&lang=js&"
import style0 from "./MerchantGiftCard.vue?vue&type=style&index=0&id=9f9b1148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9b1148",
  null
  
)

export default component.exports